import React, {useEffect,useState,useRef} from "react";
import "../../../Components/ProductRegal/ProductRegal.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
// import {useBasket, useDispatchBasket} from "../../hooks";
// import {BasketAddRemove} from "..";
import {
    getCats_api,
    getMallCats_api, getOffProducts_api,
    getProductsCategory_api, getProductsCategoryWithTag_api,
    getProductsMall_api,
    getSampleProduct_api
} from "../../../Services/apis"

import { LeftOutlined,RightOutlined } from '@ant-design/icons';

let merchantRegal = ""
let catRegal = ""

const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        1024: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        400: {
            slidesPerView: 'auto',
            spaceBetween: 8
        },
        320: {
            slidesPerView: 'auto',
            spaceBetween: 8
        }
    }

}


const catParams = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function OffRegalDesktop({item,sort=false}) {
    //hooks
    const history = useHistory();

    const [data,setData] = useState([])
    const [cats,setCats] = useState([])
    const [currentCat,set_currentCat] = useState(null)
    const [color,setColor] = useState("#E0E0E0")



    const [swiper, setSwiper] = useState(null);

    const ref = useRef(null);

    const goNext = () => {
        console.log(ref.current.swiper)
        if (ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slideNext();
        }
    };

    const goPrev = () => {
        if (ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slidePrev();
        }
    };


    useEffect( ()=>{
        getProductsMall()
    },[])

    // const selectCat = (c)=>{
    //     set_currentCat(c)
    //     getCatProducts(c.uid)
    //     if(c.name)
    //         item.title = c.name
    // }

    // const getCatProducts = async (cId)=>{
    //     try{
    //         let split = item.items[0].text.split("@")
    //         //set for more product
    //         merchantRegal = split[1]
    //         catRegal = cId
    //         const res = await getProductsCategory_api(split[1],cId)
    //         let proData = {data:res}
    //         setData(proData.data.results)
    //         if(item.items[0].link_to_uid)
    //             setColor(item.items[0].link_to_uid)
    //     }catch (e) {
    //         console.log(e)
    //     }
    //
    // }

    const getProductsMall = async ()=>{
        if(item.items[0].text){
            try{
                //set for more product
                let mallId = item.items[0].text;
                const res = await getOffProducts_api(mallId)
                let proData = {data:res}
                setData(proData.data.results)
                if(item.items[0].link_to_uid)
                    setColor(item.items[0].link_to_uid)
            }catch(e){
                console.log(e)
            }
        }
    }

    // const getCats = async(mId,pId)=>{
    //     try{
    //         const res = await getCats_api(mId,pId)
    //         // let data = res.data.result
    //         let proData = {data:res}
    //         setCats(proData.data)
    //     }catch (e) {
    //         console.log(e)
    //     }
    // }


    const seeMoreProduct = ()=>{

        history.push(`/online-store-sub-categories/${merchantRegal}/${catRegal}`)
    }

    return(
        // <span>swiper ...</span>
        <div className="desktop-regal-wr" style={{margin: "20px 16px 0 16px"}}>
            <div className="regal-handle-left" onClick={e=>{
                goNext()
            }}>
                <LeftOutlined />
            </div>
            <div className="regal-handle-right" onClick={e=>{
                goPrev()
            }}>
                <RightOutlined />
            </div>
            {/*{cats && cats.length>0?*/}
            {/*    <SwiperId {...catParams}>*/}
            {/*        {cats.map(d=>{*/}
            {/*            return(*/}
            {/*                <div className="swiper-card-container cat-slide" style={currentCat?.uid===d.uid?{backgroundColor:"#29C8B6",color:"white"}:{backgroundColor:"#E0E0E0",color:"black"}} onClick={e=>{*/}
            {/*                    selectCat(d)*/}
            {/*                }}>*/}
            {/*                    <span>{d.name}</span>*/}
            {/*                </div>*/}
            {/*            )*/}
            {/*        })}*/}

            {/*    </SwiperId>:null}*/}

            <div className="online-off-section" style={{
                backgroundColor: color,
                margin: "10px 0",
                padding: 8,
            }}>
                {data && data.length>0? <SwiperId ref={ref} {...imageParamss}>
                    <div className="swiper-card-container product-desktop-cardi" style={{backgroundColor:color,width:200}}>
                        <div className="swiper-card-body">
                            <span>{item.title?item.title:"تخفیفات ویژه"}</span>

                            {sort?<div className="regal-sort-sec">
                                <select name="" id="">
                                    <option value="">بروزترین</option>
                                    <option value="">ارزانترین</option>
                                    <option value="">گرانترین</option>
                                </select>
                            </div>:null}

                        </div>
                    </div>
                    {data.map(i=>{
                        return(
                            <div style={{width:100}}>
                                <div className="swiper-card-container-desktop" onClick={()=>{
                                    let split = item.items[0].text.split("@")
                                    // history.push(`/online-store-product/${split[1]}/${i.uid}`)
                                    history.push(`/online-store-product/${split[1]}/${i.uid}`)
                                }}>
                                    <div className="swiper-card-body" >
                                        {/*<BasketAddRemove i={i}/>*/}
                                        <div>
                                            <img src={i.image?i.image:"/other/skeleton/product.jpg"} alt=""/>
                                        </div>
                                    </div>
                                    <div className="price-section">
                                        <div className="price">
                                            {numberWithCommas(i.price)} ریال
                                        </div>
                                        {i.price_original-i.price>0?<div className="price-without-off">
                                            {numberWithCommas(i.price_original)}
                                        </div>:null}
                                    </div>
                                    {/*{i && i.discount_percentage!==0?*/}
                                    {/*    <div className="off">*/}
                                    {/*        <span>{i.discount_percentage+" % "}</span>*/}
                                    {/*    </div>:null*/}
                                    {/*}*/}
                                    <div className="info-section-desktop">
                                        <div className="name">{limitText(i.name,25)}</div>
                                        {/*<div className="weight">1500 گرمی میهن</div>*/}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>
                        <div className="swiper-card-body" style={{marginRight:20,marginTop:60}}>
                            <div className="swiper-more-card">
                                <span className="swiper-more-card-label-desktop">مشاهده محصولات </span>
                                <span onClick={seeMoreProduct} className="swiper-more-card-btn-desktop">بیشتر</span>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>
                        <div className="swiper-card-body">
                            <span></span>
                        </div>
                    </div>
                </SwiperId>:null}
            </div>
        </div>

    )
}

export {OffRegalDesktop};
